import { render, staticRenderFns } from "./HorizontalForm.vue?vue&type=template&id=21c54a68"
import script from "./HorizontalForm.vue?vue&type=script&lang=js"
export * from "./HorizontalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports